import React from 'react'
import { AppSvg, FormattedHTMLMessage, icons, Button } from '@web/walter-ui-kit'
import { useAuth } from '@web/walter-lib/auth'

import styles from '../../style.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'

function Pending() {
    const { logout, isLogoutLoading } = useAuth()

    return (
        <ModalView
            img={
                <div className={styles.waitIcon}>
                    <AppSvg size={60} svgName={icons.ic60RoundArrow} />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.verificationPendingTitle} />}
            subtitle={<FormattedHTMLMessage {...lang.verificationPendingSubtitle} />}
        >
            <Button size="l" onClick={() => logout()} isLoading={isLogoutLoading} dataPointer="sign_out_button">
                <FormattedHTMLMessage {...lang.signOutButtonText} />
            </Button>
        </ModalView>
    )
}

export default Pending
